export enum ExpirationType {
	EndDate = 0,
	NumberOfPayments = 1,
	Indefinite = 2
}
